<template>
    <div class='login-bg'>
        <div class='login'>
            <transition name='slide-fade'>

                -{{this.$route.params.Motiv}}-
                <el-card class="box-card login-box" v-if="show" v-loading="loading">
                    <el-form @submit.native.prevent>
                        <img src="../../assets/logo.png" class="img-responsive img-logo" />
                        <hr/>
                        <h5 class='card-title'>Login</h5>
                        <el-form-item label="Email">
                            <el-input type="email"  v-model="email" placeholder='Emailul dvs'></el-input>
                        </el-form-item>
                        <el-form-item label="Parola" >
                            <el-input type="password" show-password v-model="password" placeholder='Parola dvs'></el-input>
                        </el-form-item>
                         <el-link class="f-pass" @click="switchMode()" type="primary">Am uitat parola</el-link>
                        <el-form-item>
                            <el-button  type="primary" @click="login()" > Login </el-button>
                        </el-form-item>
                    </el-form>
                    <!-- <el-button @click="$router.push('/service')" class="buton">Login mecanic</el-button> -->
                </el-card>
            </transition>

            <transition name='slide-fade'>
                <el-card class="box-card login-box" v-if="forgot_password" v-loading="loading">
                    <el-form @submit.native.prevent>
                        <img src="../../assets/logo.png" class="img-responsive img-logo" />
                        <hr/>
                        <h5 class='card-title'>Am uitat parola</h5>
                        <el-form-item label="Email">
                            <el-input type="email"  v-model="email" placeholder='Emailul dvs'></el-input>
                        </el-form-item>
                         <el-link class="f-pass" @click="switchMode()" type="primary">Inapoi</el-link>
                        <el-form-item>
                            <el-button  type="primary" @click="reset_password()" > Trimite </el-button>
                        </el-form-item>
                    </el-form>
                    <!-- <el-button @click="$router.push('/service')" class="buton">Login mecanic</el-button> -->
                </el-card>
            </transition>
        </div>

        <ChangePassword-dialog ref="cpass-dlg" />
    </div>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import ChangePassword_dialog from "@/pages/Admin/ChangePassword_dialog";
    import Vue from 'vue'

    export default {
        name: "login",
        components: {
            'ChangePassword-dialog': ChangePassword_dialog
        },
        data () {
            return {
                show: false,
                forgot_password: false,
                loading: false,
                email: "",
                password: ""
            }
        },
        methods: {

            switchMode() {
                this.show = !this.show;
                this.forgot_password = !this.forgot_password;
                this.email = "";
                this.password = "";
            },

            checkPass(password) {
                let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
                return password.match(base);
            },

            reset_password: async function() {
                let response = await this.post('utilizatori/forgot_password', {email: this.email});
                if(response.Success){
                    this.$message({type: 'success', message: response.Success});
                } else if(response.Error){
                    this.$message({type: 'error', message: response.Error});
                }
               
                // await this.$router.push("/");
            },

            login: async function() {
                
                try{
                    var response = await this.post('login', { email: this.email, password: this.password, bearer: settings.get_bearer() } );
                    if(settings.get_bearer()=='') {
                        this.$message.error('Nu aveti drept de acces!');
                        return
                    }
                    if( response.Token == null && response.Eroare == 'lipsa bearer'){
                    this.$message.error('Tokenul nu corespunde!');
                    } else if (response.Token == null && response.Eroare == 'IP nepermis'){
                        this.$message.error('Accesul acestui utilizator este limitat!');
                    } else if( response.Token != null && response.Token != '' && !(this.email == '' && this.password == '')){
                        settings.set_token    ( response.Token    );
                        settings.set_drepturi ( response.Rights   );
                        settings.set_user_type( response.UserType );

                        if (this.checkPass(this.password)) {
                            this.$router.push("/rezervari");
                        } else {
                            this.$message({type: 'warning', message: 'Pentru ca parola dumneavoastra nu este sigura, va rugam sa o schimbati'})
                            this.$refs['cpass-dlg'].showPopup = true;
                        }

                    } else {
                        this.$message.error('Date gresite');
                    }
                }catch(error){
                    console.log(error);
                }
                
            },
            post: async function(url, args={}){
                this.loadingVisible      = true;
                var             response = await this.$http.post(url, args );
                this.loadingVisible      = false;
                if( settings.verify_response(response) )
                {
                    return response.body;
                }
            },
        },
        mounted: function() {
            this.show   = true;
        }
    };
</script>

<style lang="less" scoped>

    .f-pass {
        margin-bottom: 10px;
        // text-align: end !important;
    }


    .img-logo {
        max-height: 40px;
    }
    .login-box {
        margin: 50px auto;
        width: 320px;
    }

    .slide-fade-enter-active {
        transition: all 1.3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(250px);
        opacity: 0;
    }
</style>
